import { EquipmentType, IEquipmentOption } from "@oneethos/shared"
import React from "react"

type SystemLabels = {
  solarLabel?: string
  storageLabel: string
  hasRoofInput: boolean
  hasHvacInput: boolean
  hasSolarInput: boolean
  hasPowerwallQtyInput: boolean
  hasStorageQtyInput: boolean
  hasStorageCapacityInput: boolean
  hasSystemSizeInput: boolean
  pricePerWatt: string
  systemSizeKW: string
  otherContent: React.ReactNode
}

const defaultLabels: SystemLabels = {
  solarLabel: 'Solar Price',
  storageLabel: 'Storage Price',
  pricePerWatt: 'Price Per Watt',
  systemSizeKW: 'System Size (kW)',
  hasRoofInput: true,
  hasHvacInput: true,
  hasSolarInput: true,
  hasPowerwallQtyInput: false,
  hasStorageQtyInput: true,
  hasStorageCapacityInput: true,
  hasSystemSizeInput: true,
  otherContent: (
    <div className="border rounded pt-3 ps-2 pe-2 mb-3">
      <div className="mb-2"><i>* required field</i></div>
      <sup>†</sup> <i>Other refers to items on Climate First Bank's approved list:</i>
      <ul className='pt-2'>
        <li>Electric vehicle chargers</li>
        <li>Spray foam</li>
        <li>Tree trimmings/removals</li>
        <li>Ground mounts/trenching</li>
        <li>Solar pergolas/carports</li>
        <li>Critter guards</li>
        <li>Other enabling electrical upgrades</li>
      </ul>
    </div>
  )
}

export const getSystemLabels =
  (selectedEquipment: Partial<IEquipmentOption> | null): SystemLabels => {

    switch (selectedEquipment?.id) {
      case EquipmentType.TeslaRoof:
        return {
          solarLabel: 'Tesla Solar Roof',
          storageLabel: 'Powerwall Total Price',
          pricePerWatt: 'Price Per Watt',
          systemSizeKW: 'System Size (kW)',
          hasRoofInput: false,
          hasHvacInput: false,
          hasSolarInput: true,
          hasPowerwallQtyInput: true,
          hasStorageQtyInput: false,
          hasStorageCapacityInput: true,
          hasSystemSizeInput: true,
          otherContent: (
            <div className="border rounded pt-3 ps-2 pe-2 mb-3">
              <div className="mb-2"><i>* required field</i></div>
              <sup>†</sup> <i>Other refers to items on Climate First Bank's approved list:</i>
              <ul className='pt-2'>
                <li>Electric vehicle chargers</li>
                <li>Tree trimmings/removals</li>
                <li>Other electrical enabling upgrades</li>
              </ul>
            </div>
          )
        }
      case EquipmentType.TeslaSolar:
        return {
          solarLabel: 'Tesla Solar Panels',
          storageLabel: 'Powerwall Total Price',
          pricePerWatt: 'Price Per Watt',
          systemSizeKW: 'System Size (kW)',
          hasRoofInput: true,
          hasHvacInput: false,
          hasSolarInput: true,
          hasPowerwallQtyInput: true,
          hasStorageQtyInput: false,
          hasStorageCapacityInput: true,
          hasSystemSizeInput: true,
          otherContent: (
            <div className="border rounded pt-3 ps-2 pe-2 mb-3">
              <div className="mb-2"><i>* required field</i></div>
              <sup>†</sup> <i>Other refers to items on Climate First Bank's approved list:</i>
              <ul className='pt-2'>
                <li>Electric vehicle chargers</li>
                <li>Tree trimmings/removals</li>
                <li>Other electrical enabling upgrades</li>
              </ul>
            </div>
          )
        }
      case EquipmentType.StorageOnly:
        return {
          storageLabel: 'Battery Total Price',
          pricePerWatt: 'Price Per Watt Hour',
          systemSizeKW: 'Battery Capacity (kWh)',
          hasRoofInput: false,
          hasHvacInput: false,
          hasSolarInput: false,
          hasPowerwallQtyInput: false,
          hasStorageQtyInput: true,
          hasStorageCapacityInput: true,
          hasSystemSizeInput: false,
          otherContent: (
            <div className="border rounded pt-3 ps-2 pe-2 mb-3">
              <div className="mb-2"><i>* required field</i></div>
              <sup>†</sup> <i>Other refers to items on Climate First Bank's approved list:</i>
              <ul className='pt-2'>
                <li>Electric vehicle chargers</li>
                <li>Other electrical enabling upgrades</li>
              </ul>
            </div>
          )
        }
      default:
        return defaultLabels
    }
  }
